import React from 'react'
import { Link } from 'gatsby'

import Layout from '../components/layout'
import montBlanc from './images/Mont_Blanc.jpg'
import halfDay from './images/what-we-do-half-day-trainings.jpg'
import fullDay from './images/what-we-do-full-trainings.jpg'
import certifications from './images/certifications.jpg'
import special from './images/what-we-do-special-projects.jpg'
import consulting from './images/what-we-do-consulting.jpg'
import SEO from '../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO title="What We Do" keywords={[]} />
    <div id="main" role="main">
      {' '}
      <div id="content" style={{ display: 'inline-block' }}>
        <h1 className="page-title">What We Do</h1>
        <div className="float-left">
          <img
            className="alignleft"
            style={{ marginRight: '18px' }}
            src={montBlanc}
            alt="Mont Blanc"
            width={450}
          />
        </div>
        <p>
          At <em>Gómez &amp; Associates</em> our methodology and programs are
          based on a foundation of leading-edge curriculum from industry thought
          leaders. We then combine this curriculum with highly interactive
          experiential approaches – from custom business simulations to
          individual and team practice fields. Simply put, we believe that we
          must act{' '}
          <em>
            into changed behavior, not think our way into changed behavior.
          </em>
        </p>
        <p>
          We provide executive coaching to strategically align individual and
          organizational objectives. Our consultation services focus on such
          themes as: fostering innovation and change that lead to breakthrough
          solutions; talent management from developing the next generation of
          leaders to succession planning; discovering what truly motivates
          workers and how to make your organization <em>“THE”</em> great place
          to work; and unearthing the distinctive practices that lead to high
          performing teams.
        </p>
        <p>
          Using a thorough and timely needs analysis, we typically customize and
          design unique programs. The intent is to meet your specific needs and
          desired outcomes using the above program modules, simulations and
          assessments as a starting point and possible program components.
        </p>
        <p>
          &nbsp;
          <a name="consulting-expertise" />
          <br />
        </p>
        <div className="wwd-wrap">
          <div className="float-right">
            <img
              className="alignleft"
              src={consulting}
              alt="Consulting Expertise"
              width={398}
            />
          </div>
          <p>
            <span className="list-header">Consulting Expertise</span>
          </p>
          <ul className="list-what-we-do float-left">
            <li>Leadership Team Alignment</li>
            <li>Synchronizing Organizational Vision and Strategy</li>
            <li>Leadership Development Initiatives</li>
            <li>Team Effectiveness Audits</li>
            <li>Executive Coaching – Individuals and Teams</li>
            <li>Personal and Business Branding and Cultural Mapping</li>
            <li>Talent Management from New Hire to Succession Planning</li>
            <li>Discovery Interviews &amp; Needs Analysis</li>
            <li>Customized Organizational Renewal Program</li>
          </ul>
        </div>
        <p>
          &nbsp;
          <a name="special-programs-and-selected-simulations" />
          <br />
        </p>
        <div className="wwd-wrap">
          <div className="float-left">
            <img
              className="alignleft"
              src={halfDay}
              alt="Special Programs and Selected Simulations"
              width={398}
              style={{ marginRight: '23px !important' }}
            />
          </div>
          <p>
            <span className="list-header">
              Special Programs and Selected Simulations
            </span>
          </p>
          <ul
            className="list-what-we-do float-right"
            style={{ width: '437px !important' }}
          >
            <li>Action Learning Projects &amp; Case Studies</li>
            <li>
              The Art of Storytelling for Leaders – Creating a Purpose Not Just
              a Job
            </li>
            <li>High Ropes Challenge Course Facilitation</li>
            <li>
              Strategic &amp; Tactical Planning Through Backwoods Orienteering
            </li>
            <li>
              Organizational Service Projects: Corporate Social Responsibility
            </li>
            <li>Wilderness Multiday Leadership Labs</li>
            <li>
              Roads Out of Fallujah – Extraordinary Leadership Lessons in Iraq
              from an Ordinary Citizen Soldier
            </li>
            <li>
              Decision Points: Choosing Between Right and Right – What Will You
              Do?
            </li>
            <li>
              <em>60 Minutes:</em> In the Spotlight Justifying Organizational
              Strategy, Values or Purpose
            </li>
            <li>
              <em>Undercover Boss:</em> Reverse Mentoring from the Line for
              Leaders
            </li>
            <li>
              <em>The Apprentice:</em> Project Management Simulations that Cross
              Silos and Business Units
            </li>
            <li>
              <em>The Great Race:</em> Building High Performance Teams in a Sea
              of Ambiguity
            </li>
            <li>
              Conversations with <strong>Benjamin Franklin</strong> on:
              <ul className="sub-about-us">
                <li>Fostering Creativity and Innovation</li>
                <li>Our First Politically Savvy Manager</li>
                <li>Vision and Strategic Thinking: Lessons for Our Future</li>
                <li>Leadership in Times that Try Men’s Souls</li>
                <li>Modeling Financial Management</li>
              </ul>
              <p>
                <a href="http://www.benfranklinlive.org/">
                  www.benfranklinlive.org
                </a>
              </p>
            </li>
          </ul>
        </div>
        <p>
          &nbsp;
          <a name="full-day-and-multi-day-Modules-and-training-course" />
          <br />
        </p>
        <div className="wwd-wrap">
          <h3 className="sub-header">Course and Facilitation Offerings</h3>
          <div className="float-right">
            <img
              className="alignleft"
              src={fullDay}
              alt="Full Day & Multi Day Modules & Training Courses"
              width={398}
            />
          </div>
          <p>
            <span className="list-header float-left">
              Full Day &amp; Multi Day Modules &amp; Training Courses
            </span>
            <br />
            <br />
          </p>
          <ul className="list-what-we-do">
            <li>Frontline Supervisory Skills</li>
            <li>Leading Teams for Organizational Success</li>
            <li>Fostering Innovation and Creativity</li>
            <li>The Leadership Challenge® Kouzes &amp; Posner</li>
            <li>Motivating &amp; Revitalizing Disengaged Employees</li>
            <li>Reframing Organizations: The HR &amp; Symbolic Perspective</li>
            <li>The Difficult Conversations</li>
            <li>Team Effectiveness &amp; High Performance Teaming</li>
            <li>Attracting, Hiring, and Retaining Top Talent</li>
            <li>Diversity Leadership</li>
            <li>Bridging Generational Differences</li>
            <li>Effective Feedback and Creating the Development Plan</li>
            <li>Emotional Intelligence &amp; Personality Preferences</li>
            <li>Developing Others for a Transformational Workforce</li>
          </ul>
        </div>
        <p>
          &nbsp;
          <a name="half-day-modules-and-training-courses" />
          <br />
        </p>
        <div className="wwd-wrap">
          <div className="float-left">
            <img
              className="alignleft"
              src={special}
              alt="Half Day Modules & Training Courses"
              width={398}
              style={{ marginRight: '23px !important' }}
            />
          </div>
          <p>
            <span className="list-header">
              Half Day Modules &amp; Training Courses
            </span>
          </p>
          <ul className="list-what-we-do float-right">
            <li>Storytelling as a Leadership Tool</li>
            <li>Organizational Culture Mapping</li>
            <li>MicroMessaging-Turning it to an Advantage</li>
            <li>Feedback to Feedforward for Performance</li>
            <li>Getting Individuals and Teams “In the Zone”</li>
            <li>Delegation and Coaching for Success</li>
            <li>Coaching Managers to be Coaches to Develop Others</li>
            <li>Creative Training Techniques</li>
            <li>Exceptional Customer Service</li>
            <li>Leading Change Management</li>
            <li>The Resiliency Advantage for Leaders</li>
            <li>
              Preparing for the Encore Career: What Will be
              <br />
              Your Legacy?
            </li>
          </ul>
        </div>
        <p>
          &nbsp;
          <a name="certifications" />
          <br />
        </p>
        <div className="wwd-wrap">
          <div className="float-right">
            <img
              className="alignleft"
              src={certifications}
              alt="Certifications"
              width={398}
            />
          </div>
          <p>
            <span className="list-header">Certifications</span>
          </p>
          <ul className="list-what-we-do float-left">
            <li>Myers Briggs Type Indicator</li>
            <li>Four Lenses</li>
            <li>Situational Leadership</li>
            <li>Campbell Leadership Index</li>
            <li>Benchmark 360°</li>
            <li>Leadership Effectiveness Analysis</li>
            <li>Behavioral Styles</li>
            <li>Social Styles</li>
            <li>DISC</li>
            <li>Hogan Personality Inventory</li>
            <li>Emotional Intelligence</li>
            <li>FIRO-B</li>
          </ul>
        </div>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
      </div>
    </div>
  </Layout>
)

export default IndexPage
